/**
 * FHIR Organization.type CodeSystem — https://terminology.hl7.org/CodeSystem-organization-type.html
 */
export const ORGANIZATION_TYPE_SYSTEM = 'http://terminology.hl7.org/CodeSystem/organization-type';

/** Insurance Company — shared project-level payer catalog Organizations. */
export const ORGANIZATION_TYPE_INS = 'ins';

/**
 * Token search value for payer Organizations: `Organization?type={this}`.
 * Used by access-policy criteria, import upsert, and insurer typeahead search.
 */
export const ORGANIZATION_TYPE_INS_SEARCH = `${ORGANIZATION_TYPE_SYSTEM}|${ORGANIZATION_TYPE_INS}` as const;

/** FHIR `Organization.type` Coding for an insurance payer. */
export const organizationTypeInsCoding = {
  system: ORGANIZATION_TYPE_SYSTEM,
  code: ORGANIZATION_TYPE_INS,
  display: 'Insurance Company',
} as const;
